import { createAsyncTypes } from 'utils/ActionCreator'

const containerKey = 'Notifications/EndUser'

export const DATA_REQUEST_ASYNC = createAsyncTypes('DATA_REQUEST', containerKey)
export const LOCALE_REQUEST_ASYNC = createAsyncTypes('LOCALE_REQUEST', containerKey)
export const LOCALE_DELETE_ASYNC = createAsyncTypes('LOCALE_DELETE', containerKey)

export const ANNOUNCEMENT_SELECT = `${containerKey}/ANNOUNCEMENT_SELECT`
export const ADD_LANGUAGE = `${containerKey}/ADD_LANGUAGE`

export const EMAIL_FREQUENCY_OFF = { value: 0, label: 'Off' }
export const EMAIL_FREQUENCY_DAILY = { value: 1, label: 'Daily' }

export const EMAIL_FREQUENCY_OPTIONS = [
  EMAIL_FREQUENCY_OFF,
  { value: 4, label: 'Hourly' },
  { value: 5, label: 'Every 3 hours' },
  { value: 6, label: 'Every 6 hours' },
  EMAIL_FREQUENCY_DAILY,
  { value: 2, label: 'Every other day' },
  { value: 3, label: 'Weekly' },
]

const ALLOWED_SENDER_NOTIFICATION = 7
const CAMPAIGN_REPORT_911 = 11
export const REMEDIATED_EMAIL_REPORT_TRIGGER = 12
const REPLY_911_REPORT_SUCCESS = 13
const REPLY_911_REPORT_FAILURE = 14
const REMOVED_CAMPAIGN_EMAIL = 15
const EMAIL_REVERTED_TO_MAILBOX = 16
const SIMULATION_CAMPAIGN_FAILURE = 20
const TRAINING_CAMPAIGN_COMPLETION = 21
const CAMPAIGN_REPORTED = 22
export const MSP_LIMIT_LICENSE = 23
export const MSP_MAILBOX_COUNT_APPROACHING_LIMIT = 24
export const MSP_MAILBOX_COUNT_WENT_OVER_THE_LIMIT = 25

export const NOTIFY_END_USER_NOTIFICATIONS = [
  CAMPAIGN_REPORT_911,
  REPLY_911_REPORT_SUCCESS,
  REPLY_911_REPORT_FAILURE,
  ALLOWED_SENDER_NOTIFICATION,
  REMOVED_CAMPAIGN_EMAIL,
  CAMPAIGN_REPORTED,
]

export const MSP_NOTIFICATIONS = [
  MSP_LIMIT_LICENSE,
  MSP_MAILBOX_COUNT_APPROACHING_LIMIT,
  MSP_MAILBOX_COUNT_WENT_OVER_THE_LIMIT,
]

export const NOTIFY_END_USER_NOTIFICATIONS_BY_FREQUENCY = [
  REMEDIATED_EMAIL_REPORT_TRIGGER,
  EMAIL_REVERTED_TO_MAILBOX,
  MSP_MAILBOX_COUNT_APPROACHING_LIMIT,
  MSP_MAILBOX_COUNT_WENT_OVER_THE_LIMIT,
]

export const INCLUDE_SPAM_USER_NOTIFICATIONS = [REMEDIATED_EMAIL_REPORT_TRIGGER]
export const ANNOUNCEMENT_HEADER = [
  ...INCLUDE_SPAM_USER_NOTIFICATIONS,
  ...NOTIFY_END_USER_NOTIFICATIONS,
  ...MSP_NOTIFICATIONS,
]

export const mapPlaceholderKeyByTrigger = {
  5: 'endUserPhishingTrainingReminder',
  6: 'endUserKnownSender',
  9: 'endUserReadMaliciousEmail',
  10: 'endUserMentioningComments',
  12: 'endUserQuarantinedEmailsReport',
}
